import { getApiClient } from './client';
import type { User } from '../types/user';

export interface AuthResponse {
  user: User;
  token?: string;
  expiresAt: string;
}

export interface InitAuthResponse {
  authUrl: string;
}

export async function initGoogleAuth(tenant: string, redirectUrl?: string): Promise<InitAuthResponse> {
  const client = getApiClient(tenant);
  return client.post<InitAuthResponse>('/auth/google/init', { redirectUrl });
}

export async function handleGoogleCallback(
  tenant: string,
  code: string,
  state: string,
  inviteToken?: string
): Promise<AuthResponse> {
  const client = getApiClient(tenant);
  return client.post<AuthResponse>('/auth/google/callback', { code, state, inviteToken });
}

export async function initFacebookAuth(tenant: string, redirectUrl?: string): Promise<InitAuthResponse> {
  const client = getApiClient(tenant);
  return client.post<InitAuthResponse>('/auth/facebook/init', { redirectUrl });
}

export async function handleFacebookCallback(
  tenant: string,
  code: string,
  state: string
): Promise<AuthResponse> {
  const client = getApiClient(tenant);
  return client.post<AuthResponse>('/auth/facebook/callback', { code, state });
}

export async function getCurrentUser(tenant: string): Promise<{ user: User }> {
  const client = getApiClient(tenant);
  return client.get<{ user: User }>('/auth/me');
}

export async function logout(tenant: string): Promise<void> {
  const client = getApiClient(tenant);
  await client.post('/auth/logout');
}
